export default __webpack_public_path__ + "static/media/segre24.91dcaf6b.jpg";